import DeviceChart from './DeviceChart';

export default DeviceChart;
